import React from 'react';
import moment from 'moment';

import CurrencySign from 'components/price/CurrencySign.component';
import { STYLE_DISPLAY_NONE } from 'constants/misc.const';
import S from 'constants/string.const';
import asArray from 'utils/arrays/asArray.util';
import { isEnvMobile } from 'utils/env/determine.util';
import logger from 'utils/logger.util';
import createNodeKey from 'utils/react/createNodeKey.util';
const L = logger('ClientList');

const STICKY_NAVBAR_CLIENTS_SELECTOR = '.sticky-navbar-clients';

const fromBirthdayToFormatted = (birthday) => {
  if (!birthday) return S.empty;

  const [day, month, year] = birthday.split('/');

  if (year) return moment(`${year}${month}${day}`).format('D MMM  YY'); // TODO: replace moment() with utility funcion

  return moment(`2020${month}${day}`).format('D MMM'); // TODO: replace moment() with utility funcion
};

const fromPatchTestDateToFormatted = (patchTestDate) => {
  if (!patchTestDate) return S.empty;

  const [day, month, year] = patchTestDate.split('/');
  return moment(`${year}${month}${day}`).format('D MMM  YY'); // TODO: replace moment() with utility funcion
};

class ClientList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: true,
      isNameAcs: false,
      isMobileAsc: true,
      isLastVisitAsc: false,
      isNextVisitAsc: false,
      isToatalVisitsAsc: true,
      isAverageAsc: true,
      isNoShowAsc: true,
      isCancelAsc: true,
      isLastSMSSentAsc: true,
      isTotalSpendAsc: true,
      isEmailAsc: true,
      isPatchTestAsc: true,
      isBirthdayAsc: true,
      isTagsAsc: true,
    };
  }

  toggleChange = () => {
    this.setState({ isChecked: !this.state.isChecked });
    this.props.markAllClientsSelect(!this.state.isChecked);
  };

  toggleItemChange = (clientId, clientSelection) => {
    this.props.markClientSelect(clientId, !clientSelection);
  };

  sortItemCliked = (tableRow) => {
    if (tableRow === 'clientName') {
      this.setState({ isNameAcs: !this.state.isNameAcs });
      this.props.sortClientList(tableRow, this.state.isNameAcs);
      this.props.trackEvent('sort_clients_name');
    }
    if (tableRow === 'mobile') {
      this.setState({ isMobileAsc: !this.state.isMobileAsc });
      this.props.sortClientList(tableRow, this.state.isMobileAsc);
      this.props.trackEvent('sort_clients_mobile');
    }
    if (tableRow === 'lastVisit') {
      this.setState({ isLastVisitAsc: !this.state.isLastVisitAsc });
      this.props.sortClientList(tableRow, this.state.isLastVisitAsc);
      this.props.trackEvent('sort_clients_lastvisit');
    }
    if (tableRow === 'nextVisit') {
      this.setState({ isNextVisitAsc: !this.state.isNextVisitAsc });
      this.props.sortClientList(tableRow, this.state.isNextVisitAsc);
      this.props.trackEvent('sort_clients_nextvisit');
    }
    if (tableRow === 'totalVisits') {
      this.setState({ isToatalVisitsAsc: !this.state.isToatalVisitsAsc });
      this.props.sortClientList(tableRow, this.state.isToatalVisitsAsc);
      this.props.trackEvent('sort_clients_totalvisits');
    }
    if (tableRow === 'averageBill') {
      this.setState({ isAverageAsc: !this.state.isAverageAsc });
      this.props.sortClientList(tableRow, this.state.isAverageAsc);
      this.props.trackEvent('sort_clients_avgbill');
    }
    if (tableRow === 'noShow') {
      this.setState({ isNoShowAsc: !this.state.isNoShowAsc });
      this.props.sortClientList(tableRow, this.state.isNoShowAsc);
      this.props.trackEvent('sort_clients_noshow');
    }
    if (tableRow === 'Cancellations') {
      this.setState({ isCancelAsc: !this.state.isCancelAsc });
      this.props.sortClientList(tableRow, this.state.isCancelAsc);
      this.props.trackEvent('sort_clients_cancellations');
    }
    if (tableRow === 'lastSmsSent') {
      this.setState({ isLastSMSSentAsc: !this.state.isLastSMSSentAsc });
      this.props.sortClientList(tableRow, this.state.isLastSMSSentAsc);
      this.props.trackEvent('sort_clients_last_sms');
    }
    if (tableRow === 'totalSpend') {
      this.setState({ isTotalSpendAsc: !this.state.isTotalSpendAsc });
      this.props.sortClientList(tableRow, this.state.isTotalSpendAsc);
      this.props.trackEvent('sort_total_spend');
    }
    if (tableRow === 'email') {
      this.setState({ isEmailAsc: !this.state.isEmailAsc });
      this.props.sortClientList(tableRow, this.state.isEmailAsc);
      this.props.trackEvent('sort_email');
    }
    if (tableRow === 'invalid_patch_test') {
      this.setState({ isPatchTestAsc: !this.state.isPatchTestAsc });
      this.props.sortClientList(tableRow, this.state.isPatchTestAsc);
      this.props.trackEvent('sort_patch_test');
    }
    if (tableRow === 'birthday') {
      this.setState({ isBirthdayAsc: !this.state.isBirthdayAsc });
      this.props.sortClientList(tableRow, this.state.isBirthdayAsc);
      this.props.trackEvent('sort_birthday');
    }
    if (tableRow === 'clientTags') {
      this.setState({ isTagsAsc: !this.state.isTagsAsc });
      this.props.sortClientList(tableRow, this.state.isTagsAsc);
      this.props.trackEvent('sort_tags');
    }
  };

  render() {
    if (isEnvMobile({ regex: true })) {
      const div = document.querySelector(STICKY_NAVBAR_CLIENTS_SELECTOR);
      if (div) {
        div.addEventListener('touchstart touchmove touchend', (ev) => void ev.preventDefault());
      } else {
        L.warn('render()', 'Missing element:', STICKY_NAVBAR_CLIENTS_SELECTOR);
      }
    }

    return (
      <>
        <div className="sticky-navbar-clients">
          <div className="client-list-header">
            <div className="opt-chk">
              <div className="cb-item">
                <div className="checkbox-box-custom-wrap">
                  <input
                    type="checkbox"
                    className="checkbox-box-custom"
                    id="clints-opted-in"
                    checked={this.props.isOptChecked}
                    onChange={this.props.toggleOptChange}
                  />
                  <label className="checkbox-box-label" htmlFor="clints-opted-in">
                    <div className="checkbox-box-custom-icon">
                      <span className="ic-sml-18px ic_check_white_18" />
                    </div>
                  </label>
                </div>
                <span className="span-text">Only show clients opted-in for marketing</span>
                <div className="client-oped-icon">
                  <span className="tooltip">
                    <div className="tooltip-centered">
                      It is against GDPR regulation to send promotional marketing messages to clients without obtaining
                      their consent in advance. Ticking this will reveal only clients who are marked as opted-in for
                      marketing in their Client Profile.
                    </div>
                  </span>
                </div>
              </div>
              <div className="cb-item">
                <div className="checkbox-box-custom-wrap chk-nophone">
                  <input
                    type="checkbox"
                    className="checkbox-box-custom"
                    id="clients-hide"
                    checked={this.props.isHideChecked}
                    onChange={this.props.toggleHideChange}
                  />
                  <label className="checkbox-box-label" htmlFor="clients-hide">
                    <div className="checkbox-box-custom-icon">
                      <span className="ic-sml-18px ic_check_white_18" />
                    </div>
                  </label>
                </div>
                <span className="span-text">Hide clients with no mobile number</span>
              </div>
            </div>
          </div>
        </div>
        <div className="sticky-container-clients">
          <div className="sticky-table-marketing">
            <table className="table-clients">
              <thead>
                <tr>
                  <th className="check-box-row">
                    <div className="checkbox-box-custom-wrap">
                      <input
                        type="checkbox"
                        className="checkbox-box-custom"
                        id="clients-check"
                        checked={this.state.isChecked}
                        onChange={this.toggleChange}
                      />
                      <label className="checkbox-box-label" htmlFor="clients-check">
                        <div className="checkbox-box-custom-icon">
                          <span className="ic-sml-18px ic_check_white_18" />
                        </div>
                      </label>
                    </div>
                  </th>
                  <th className="c-name">
                    <div
                      role="button"
                      tabIndex={0}
                      onClick={() => {
                        this.sortItemCliked('clientName');
                      }}
                      className="ht-name"
                    >
                      Client name
                      <div className="diamond-arrow" />
                    </div>
                  </th>
                  <th className="c-mobile">
                    <div
                      role="button"
                      tabIndex={0}
                      onClick={() => {
                        this.sortItemCliked('mobile');
                      }}
                      className="ht-name"
                    >
                      Mobile
                      <div className="diamond-arrow" />
                    </div>
                  </th>
                  <th className="c-last-v">
                    <div
                      role="button"
                      tabIndex={0}
                      onClick={() => {
                        this.sortItemCliked('lastVisit');
                      }}
                      className="ht-name"
                    >
                      <span>
                        <span>Last</span>
                        <span>visit</span>
                      </span>

                      <div className="diamond-arrow" />
                    </div>
                  </th>
                  <th className="c-next-v">
                    <div
                      role="button"
                      tabIndex={0}
                      onClick={() => {
                        this.sortItemCliked('nextVisit');
                      }}
                      className="ht-name"
                    >
                      <span>
                        <span>Next</span>
                        <span>visit</span>
                      </span>
                      <div className="diamond-arrow" />
                    </div>
                  </th>
                  <th className="c-total-v">
                    <div
                      role="button"
                      tabIndex={0}
                      onClick={() => {
                        this.sortItemCliked('totalVisits');
                      }}
                      className="ht-name"
                    >
                      <span>
                        <span>Total</span>
                        <span>visits</span>
                      </span>
                      <div className="diamond-arrow" />
                    </div>
                  </th>
                  <th className="c-total-s">
                    <div
                      role="button"
                      tabIndex={0}
                      onClick={() => {
                        this.sortItemCliked('totalSpend');
                      }}
                      className="ht-name"
                    >
                      <span>
                        <span>Total</span>
                        <span>spend</span>
                      </span>
                      <div className="diamond-arrow" />
                    </div>
                  </th>
                  <th className="c-average">
                    <div
                      role="button"
                      tabIndex={0}
                      onClick={() => {
                        this.sortItemCliked('averageBill');
                      }}
                      className="ht-name"
                    >
                      <span>
                        <span>Average</span>
                        <span>bill</span>
                      </span>
                      <div className="diamond-arrow" />
                    </div>
                  </th>
                  <th className="c-no-show">
                    <div
                      role="button"
                      tabIndex={0}
                      onClick={() => {
                        this.sortItemCliked('noShow');
                      }}
                      className="ht-name"
                    >
                      <span>
                        <span>No-</span>
                        <span>shows</span>
                      </span>
                      <div className="diamond-arrow" />
                    </div>
                  </th>
                  <th className="c-cancellation">
                    <span
                      role="button"
                      tabIndex={0}
                      onClick={() => {
                        this.sortItemCliked('Cancellations');
                      }}
                      className="ht-name"
                    >
                      Cancellations
                      <div className="diamond-arrow" />
                    </span>
                  </th>
                  <th className="c-last-patch-test">
                    <div
                      role="button"
                      tabIndex={0}
                      onClick={() => {
                        this.sortItemCliked('invalid_patch_test');
                      }}
                      className="ht-name"
                    >
                      <span>
                        <span>Last</span>
                        <span>patch test</span>
                      </span>
                      <div className="diamond-arrow" />
                    </div>
                  </th>
                  <th className="c-bday">
                    <span
                      role="button"
                      tabIndex={0}
                      onClick={() => {
                        this.sortItemCliked('birthday');
                      }}
                      className="ht-name"
                    >
                      Birthday
                      <div className="diamond-arrow" />
                    </span>
                  </th>
                  <th className="c-tags">
                    <div
                      role="button"
                      tabIndex={0}
                      onClick={() => {
                        this.sortItemCliked('clientTags');
                      }}
                      className="ht-name"
                    >
                      <span>
                        <span>Client</span>
                        <span>tags</span>
                      </span>
                      <div className="diamond-arrow" />
                    </div>
                  </th>
                  <th className="c-lastSmsSent">
                    <div
                      role="button"
                      tabIndex={0}
                      onClick={() => {
                        this.sortItemCliked('lastSmsSent');
                      }}
                      className="ht-name"
                    >
                      <span>
                        <span>Text</span>
                        <span>last sent</span>
                      </span>
                      <div className="diamond-arrow" />
                    </div>
                  </th>
                  <th className="c-email">
                    <div
                      role="button"
                      tabIndex={0}
                      onClick={() => {
                        this.sortItemCliked('email');
                      }}
                      className="ht-name"
                    >
                      Email
                      <div className="diamond-arrow" />
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {this.props.clientList.find((client) => client.show === true) &&
                  this.props.clientList
                    .filter((client) => client.show === true)
                    .map((client, clientIndex) => {
                      const {
                        birthday,
                        patch_test_date: patchTestDate,
                        id: clientId,
                        client_tags: clientTags,
                        selected,
                        requested_opt_out: requestedOptOut,
                        stopped_sms: stoppedSms,
                        user_name: userName,
                        phone,
                        last_visit: lastVisit,
                        next_visit: nextVisit,
                        visits_count: visitsCount,
                        visits_total_cost: visitsTotalCost,
                        no_shows_count: noShowsCount,
                        canceled_count: canceledCount,
                        last_marketing_message: lastMarketingMessage,
                        email,
                      } = client ?? {};

                      return (
                        <tr
                          key={createNodeKey({
                            unique: clientId,
                            index: clientIndex,
                          })}
                        >
                          <td className="checkbox-td">
                            <div className="checkbox-box-custom-wrap">
                              <input
                                type="checkbox"
                                className="checkbox-box-custom"
                                id={`clints-check-${clientId}`}
                                checked={selected && !requestedOptOut && !stoppedSms}
                                onChange={() => void this.toggleItemChange(clientId, selected)}
                                disabled={requestedOptOut === true && stoppedSms === true}
                              />
                              <label className="checkbox-box-label" htmlFor={`clints-check-${clientId}`}>
                                <div className="checkbox-box-custom-icon">
                                  <span className="ic-sml-18px ic_check_white_18" />
                                </div>
                              </label>
                              <div hidden={requestedOptOut !== true}>
                                <span className="tooltip">
                                  <div className="tooltip-centered">
                                    This client has opted out of receiving Marketing texts. If you have their permission
                                    to opt them back in, you can do so in their client profile
                                  </div>
                                </span>
                              </div>
                              <div hidden={stoppedSms !== true}>
                                <span className="tooltip">
                                  <div className="tooltip-centered">
                                    This client has opted out of receiving all text message communication. They can opt
                                    back in by replying START to any previous text you have sent them
                                  </div>
                                </span>
                              </div>
                            </div>
                          </td>
                          <td className="c-name text-cap">{userName}</td>
                          <td className="c-mobile">{phone}</td>
                          {lastVisit && <td className="c-last-v">{moment(lastVisit).format('D MMM  YY')}</td>}
                          {!lastVisit && <td className="c-last-v">-</td>}
                          <td className="c-next-v">{nextVisit ? moment(nextVisit).format('D MMM  YY') : ' '}</td>
                          <td className="c-total-v">{visitsCount}</td>
                          <td className="c-total-s">
                            <CurrencySign />
                            {visitsTotalCost}
                          </td>
                          <td className="c-average">
                            <CurrencySign />
                            {Math.round(visitsCount === 0 ? 0 : ((visitsTotalCost / visitsCount) * 100) / 100)}
                          </td>

                          <td className="c-no-show">{noShowsCount}</td>
                          <td className="c-cancellation">{canceledCount}</td>
                          <td className="c-last-patch-test">{fromPatchTestDateToFormatted(patchTestDate)}</td>
                          <td className="c-bday">{fromBirthdayToFormatted(birthday)}</td>
                          <td className="c-tags">
                            <div className="marketing-tags-list">
                              {asArray(clientTags).map(({ emoticon, name, id }, index) => (
                                <div
                                  className="tag-icon"
                                  key={createNodeKey({
                                    unique: id,
                                    index,
                                  })}
                                >
                                  {emoticon}
                                  {S.space}
                                  {name}
                                </div>
                              ))}
                            </div>
                          </td>
                          <td className="c-lastSmsSent">
                            {lastMarketingMessage ? moment(lastMarketingMessage).format('D MMM  YY') : '-'}
                          </td>
                          <td className="c-email" style={{ wordBreak: 'break-all' }}>
                            {email}
                          </td>
                        </tr>
                      );
                    })}
              </tbody>
            </table>
          </div>
        </div>
        {/* TABLE with clients name and email for download as EXCEL should be not visible in UI */}
        <table id="table-clients-name-email-to-excel" style={STYLE_DISPLAY_NONE} className="hidden">
          <thead>
            <tr>
              <th className="c-name">Client name</th>
              <th className="c-email">Email</th>
            </tr>
          </thead>
          <tbody>
            {this.props.clientList.find((client) => client.show === true) &&
              this.props.clientList
                .filter((client) => client.show === true)
                .sort((a, b) => (a.user_name < b.user_name ? -1 : 1))
                .filter((client) => client.email)
                .filter((client) => client.requested_opt_out !== true)
                .map((client) => (
                  <tr key={`${client.id}`}>
                    <td>{client.user_name}</td>
                    <td>{client.email}</td>
                  </tr>
                ))}
          </tbody>
        </table>
      </>
    );
  }
}

export default ClientList;
